import { createReducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import calendarActions from './calendarActions';

const searchParams = new URL(document.location)?.searchParams;

const handleSetCalendarSettings = (state, actions) => {
  if (actions.payload.activeWorkerId) {
    config.activeWorkerId = actions.payload.activeWorkerId;
  }
  return { ...state, ...actions.payload };
};
const editCalendarSettings = state => {
  config.is_income_shown = false;
  return { ...state, ...{ incomeShown: false } };
};
const tutorialSecondStep = state => {
  return { ...state, firstStep: false };
};
const HideReminderTutorialSecondStep = state => {
  config.shouldReminderTutorialShow = false;
  return { ...state, showRemindersTutorial: false };
};
const calendarSettings = createReducer(
  {
    activeWorkerId:
      searchParams?.get('worker_id') && searchParams?.get('worker_id') !== '-1'
        ? searchParams?.get('worker_id')
        : config.activeWorkerId,
    calendarView: searchParams?.get('calendar_view_type') || config.calendar.initialView,
    incomeShown: config.is_income_shown && config.permissions?.calendar?.calendar_can_see_summary,
  },
  {
    [calendarActions.setCalendarSettings]: handleSetCalendarSettings,
    [calendarActions.showToast]: editCalendarSettings,
  },
);

const statisticToast = createReducer(false, {
  [calendarActions.showToast]: () => true,
  [calendarActions.hideToast]: () => false,
});

const calendarTutorial = createReducer(
  {
    showTutorial: config.shouldTutorialShow,
    firstStep: true,
    showRemindersTutorial: config.shouldReminderTutorialShow,
  },
  {
    [calendarActions.hideTutorial]: () => ({ showTutorial: false, firstStep: true }),
    [calendarActions.hideReminderTutorial]: HideReminderTutorialSecondStep,
    [calendarActions.tutorialSecondStep]: tutorialSecondStep,
  },
);

export default combineReducers({
  calendarTutorial,
  statisticToast,
  calendarSettings,
});
